import React from 'react';
import { medicalProfileFilesService } from '../../../../../primary-record-types/apiTypes';
import MedicalProfileFileAudioPlayer from '../../../../shared/AudioPlayer/MedicalProfileFileAudioPlayer';
import { View } from 'react-native';
import MainContentContainer from '../../../../v2BaseComponents/MainContentContainer';
import TranscriptDisplay from './TranscriptDisplay';
import SkeletonLoadingContainer from '../../../../v2BaseComponents/SkeletonLoadingContainer';
import { contentStackSpacing } from '../../../../v2BaseComponents/Stack';

export type AudioPlayerOwnProps = {
    file: medicalProfileFilesService.MedicalProfileFileListItem;
    defaultStartTime?: number;
    renderTranscript?: (position: number | null) => React.ReactNode;
};

export type AudioPlayerProps = AudioPlayerOwnProps;

const AudioPlayer: React.FC<AudioPlayerProps> = (props) => {
    return (
        <View style={{ width: '100%', height: '100%' }}>
            <MainContentContainer flex={1}>
                <MedicalProfileFileAudioPlayer
                    medicalProfileId={props.file.medicalProfileId}
                    medicalProfileFileId={props.file.medicalProfileFileId}
                    startTime={props.defaultStartTime}
                    renderTranscript={(args) => (
                        <View style={{ width: '100%', flex: 1, paddingTop: 20 }}>
                            <SkeletonLoadingContainer
                                isLoading={args.isLoading}
                                skeletonStyle={{ flex: 1, marginTop: contentStackSpacing }}
                            >
                                {args.isLoading ? null : (
                                    <TranscriptDisplay
                                        transcript={args.transcript}
                                        position={args.position}
                                        isPlaying={args.isPlaying}
                                        onSetPosition={args.onSetPosition}
                                    />
                                )}
                            </SkeletonLoadingContainer>
                        </View>
                    )}
                />
            </MainContentContainer>
        </View>
    );
};

export default React.memo(AudioPlayer);
